import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { IPeriods, ISectionState } from "@/store/modules/section/types";

type AuthGetterTree = GetterTree<ISectionState, RootState>;

export const getters: AuthGetterTree = {
  periods(state: ISectionState): IPeriods {
    if (state.periods) {
      return Object.entries(state.periods)
        .filter(period => period[1].sections.length)
        .reduce((a: any, c: any) => ({ ...a, [c[0]]: c[1] }), {});
    }

    return {};
  },
};
